/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_004: Question = {
  id: 'gov-004-programmes-financement-services',
  oldId: '4',
  title: 'Mise en place de programmes de financement ou de services',
  number: '1.4',
  idEM: 13,
  frequency: 1,
  type: QuestionType.ACTIVITY,
  description: ['L’organisme municipal a mis en place des programmes offrant du financement ou des biens et services liés à des activités visant la conservation de la biodiversité. Ces programmes sont destinés aux citoyens, aux entreprises ou aux organisations. L’organisation municipale finance ces projets, mais n’y participe pas.'],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoringFct: (data: string[]) => parseFloat(data[0]),
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_gov_004__v3: Question = {
  ...question_gov_004,
  title: 'Mise en place de programmes de financement ou de services sur le domaine privé',
};

export const question_gov_004_v2: Question = question_gov_004;
export const question_gov_004_v3: Question = question_gov_004__v3;
